// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PopupTemplateSecond_wrapper__1tXyD","box":"PopupTemplateSecond_box__hJsq4","box2":"PopupTemplateSecond_box2__3E1RU","button":"PopupTemplateSecond_button__PjkTx"};